class OrderDetails {
  constructor(data, payments = []) {
    this.target = data;
    this._payments = payments;
  }

  get id() {
    return Number(this.target.orderId);
  }

  get deviceOrderUuid() {
    return this.target.deviceOrderUuid;
  }

  get status() {
    return this.target.orderStatus || "";
  }

  get confirmationCode() {
    return this.target.confirmationCode || "";
  }

  get cardNumberLastFour() {
    return this.target.cardNumberLastFour || "";
  }

  get tip() {
    return Number(this.target.tip || this.target.orderTip);
  }

  get fee() {
    return Number(this.target.fee || this.target.orderFee);
  }

  get tax() {
    return Number(this.target.tax || this.target.orderTax);
  }

  get subTotal() {
    return Number(this.target.subtotal || this.target.orderSubtotal);
  }

  get total() {
    return Number((this.target.payments && this.target.payments[0].amount) || this.target.orderTotal);
  }

  get date() {
    return this.target.orderDate || new Date().toDateString();
  }

  get promoAmount() {
    return Number(this.target.promoAmount);
  }

  get payments() {
    return this._payments;
  }
}

export default OrderDetails;
